import { PlateEditor } from '@affine/core/plate';
import {
  type EditorHost,
  ReactHTMLElement,
} from '@blocksuite/affine/block-std';
import { WithDisposable } from '@blocksuite/affine/global/utils';
import type { BlockModel } from '@blocksuite/affine/store';
import { MarkdownPlugin } from '@udecode/plate-markdown';
import { property } from 'lit/decorators.js';

import {
  extractMarkdownFromDoc,
  insertMarkdownAbove,
  insertMarkdownBelow,
  replaceWithMarkdown,
} from '../utils';

export class DocnboardChatPanelAI extends WithDisposable(ReactHTMLElement) {
  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  override async connectedCallback(): Promise<void> {
    const content = await extractMarkdownFromDoc(this.host);

    this.renderApp(
      <PlateEditor
        content={content}
        onInsertBelow={editor => {
          const markdown = editor.getApi(MarkdownPlugin).markdown.serialize();

          insertMarkdownBelow(this.host, markdown).catch(err => {
            console.error(err);
          });

          this.abortController.abort();
        }}
        onInsertAbove={editor => {
          const markdown = editor.getApi(MarkdownPlugin).markdown.serialize();

          insertMarkdownAbove(this.host, markdown).catch(err => {
            console.error(err);
          });

          this.abortController.abort();
        }}
        onDiscard={() => {
          this.abortController.abort();
        }}
        onReplaceSelection={editor => {
          const markdown = editor.getApi(MarkdownPlugin).markdown.serialize();

          replaceWithMarkdown(this.host, markdown).catch(err => {
            console.error(err);
          });

          this.abortController.abort();
        }}
      />
    );
  }

  @property({ attribute: false })
  accessor abortController!: AbortController;

  @property({ attribute: false })
  accessor host!: EditorHost;

  @property({ attribute: false })
  accessor model!: BlockModel;
}

declare global {
  interface HTMLElementTagNameMap {
    'docnboard-chat-panel-ai': DocnboardChatPanelAI;
  }
}
